import React from 'react'
import { Card } from './ui'
import { WarningIcon } from '../icons'
import { UnsupportedModuleViewerMetaProps } from '../data/types'

type Props = {
    moduleType: string
    meta: UnsupportedModuleViewerMetaProps
}

export const UnsupportedModuleViewer = (props: Props) => {
    const { moduleType, meta } = props

    return (
        <Card>
            <div className="p-12 text-center">
                <WarningIcon className="w-16 h-16 mx-auto mb-4 text-warn-500" />
                <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                    {meta.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-2">
                    {meta.message.replace('{type}', moduleType)}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-500">
                    {meta.supportedTypes}
                </p>
            </div>
        </Card>
    )
}
